import React from 'react';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { OfferPrices, PricePrice } from 'src/types';
import ShippingLabelComponent from 'src/components/shipping-label';
import { MediumUp } from 'src/ui/block/';
import { PriceDisplay } from 'src/components/price-list/types';

interface IShippingLabel {
  price?: PricePrice | null;
  offerPrice?: OfferPrices | null;
  priceDisplay: PriceDisplay;
}

export const ShippingLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IShippingLabel>
>> = props => {
  const { price, priceDisplay } = props;

  if (!price) {
    return null;
  }

  return (
    <MediumUp>
      {price.exclShipping && (
        <BodySmallText>
          <ShippingLabelComponent
            toneDown
            exclShipping={price.exclShipping}
            inclShipping={price.inclShipping}
            priceDisplay={priceDisplay}
          />
        </BodySmallText>
      )}
    </MediumUp>
  );
};
